(() => {
  const script = document.querySelector('script[data-wek-routing]');
  if (!script) return;
  const theme = script.dataset.theme;
  const suffix = script.dataset.view.toLowerCase();
  const views = ['WEK-Landing', 'OLDwek-Evaluate', 'OLDwek-Order', 'WEK-Custom-Formulation', 'wek-documentation', 'wek-partner'];
  const approved = new Map(views.map(view => [view.toLowerCase(), view]));
  const flow = suffix.includes('order') || suffix === 'wek-b2b' ? views[2] : views[1];
  const aliases = new Map([
    ['wek-evaluate', views[1]], ['wek-valuate-v2', views[1]], ['wek-valuate-2', views[1]],
    ['wek-order', views[2]], ['wek-order-v2', views[2]],
    ['wek-intake', views[3]], ['wholesale-rd', views[0]],
    ['wek-checkout', 'wek-checkout'], ['wek-order-v2-purchase', 'wek-order-v2-purchase'],
    ['wek-b2b', 'wek-b2b'], ['wek-function-catalog', 'wek-function-catalog'],
    ['wek-order-gallons', 'wek-order-gallons']
  ]);
  function canonical(value) {
    const name = (value || '').toLowerCase();
    return approved.get(name) || aliases.get(name) || null;
  }
  if (!canonical(suffix)) return;
  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid'];
  function attributionFor(params) {
    const values = {};
    for (const key of attributionKeys) {
      const value = params.get(key);
      if (value && value.length <= 2048) values[key] = value;
    }
    return values;
  }
  function carryAttribution(url) {
    if (attributionKeys.some(key => url.searchParams.has(key))) return;
    for (const [key, value] of Object.entries(attributionFor(new URL(location.href).searchParams))) {
      url.searchParams.set(key, value);
    }
  }
  function route(raw, link) {
    if (!raw || raw.startsWith('#')) return raw;
    let url;
    try { url = new URL(raw, location.origin); } catch { return raw; }
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return raw;
    const path = url.pathname.replace(/^\/[a-z]{2}(?:-[A-Z]{2})?(?=\/)/, '');
    if (/^\/(account|customer_authentication|checkout|checkouts|apps|policies)(\/|$)/.test(path) || /^\/pages\/ws-/.test(path)) return raw;
    let view = url.searchParams.get('view');
    const mapped = canonical(view);
    if (mapped) view = mapped;
    if (path === '/pages/wholesale' && mapped) {
      view = mapped;
    } else if (/^\/cart\/?$/.test(path) && mapped === 'wek-b2b') {
      view = mapped;
    } else if ((/^\/search\/?$/.test(path) || /^\/(?:collections\/[^/]+\/)?products\/[^/]+\/?$/.test(path) || /^\/collections\/[^/]+(?:\/[^/]+)?\/?$/.test(path)) && mapped) {
      view = mapped;
    } else if (/^\/collections\/wholesale-products\/?$/.test(path) && !view) {
      view = flow;
    } else return raw;
    if (!view) return raw;
    carryAttribution(url);
    url.searchParams.set('view', view);
    if (theme) url.searchParams.set('preview_theme_id', theme);
    else url.searchParams.delete('preview_theme_id');
    if (theme) { url.searchParams.set('_fd', '0'); url.searchParams.set('pb', '0'); }
    else { url.searchParams.delete('_fd'); url.searchParams.delete('pb'); }
    return url.pathname + url.search + url.hash;
  }
  function wire(root) {
    root.querySelectorAll('a[href]').forEach(link => {
      if (link.hasAttribute('data-wek-checkout-handoff')) return;
      const before = link.getAttribute('href');
      const after = route(before, link);
      if (after !== before) link.setAttribute('href', after);
    });
    root.querySelectorAll('form[action]').forEach(form => {
      const url = new URL(form.action, location.origin);
      if (url.origin !== location.origin || !/\/search\/?$/.test(url.pathname)) return;
      const existing = form.querySelector('[name="view"]');
      const view = canonical(existing?.value || url.searchParams.get('view'));
      if (!view) return;
      const existingAttribution = attributionKeys.some(key => url.searchParams.has(key) || form.querySelector(`[name="${key}"]:not([data-wek-attribution])`));
      const values = existingAttribution ? {} : attributionFor(new URL(location.href).searchParams);
      form.querySelectorAll('input[data-wek-attribution]').forEach(input => {
        if (!Object.hasOwn(values, input.name)) input.remove();
      });
      for (const [name, value] of Object.entries(values)) {
        let input = form.querySelector(`input[data-wek-attribution][name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.setAttribute('data-wek-attribution', '');
          form.append(input);
        }
        input.value = value;
      }
      if (!theme) form.querySelectorAll('[name="preview_theme_id"], [name="_fd"], [name="pb"]').forEach(input => input.remove());
      for (const [name, value] of Object.entries(theme ? {view, preview_theme_id:theme, _fd:'0', pb:'0'} : {view})) {
        let input = form.querySelector(`[name="${name}"]`);
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
        if (input.value !== value) input.value = value;
      }
    });
  }
  wire(document);
  const observer = new MutationObserver(() => { observer.disconnect(); wire(document); observe(); });
  const observe = () => observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['href']});
  observe();
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link && !link.hasAttribute('data-wek-checkout-handoff')) {
      link.setAttribute('href', route(link.getAttribute('href'), link));
      const url = new URL(link.href, location.origin);
      if (/\/cart\/?$/.test(url.pathname) && url.searchParams.get('view') === 'wek-b2b' && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
        event.preventDefault(); event.stopImmediatePropagation(); location.assign(link.href);
      }
    }
  }, true);
})();

